import React, { useState } from 'react';
import { X, AlertTriangle, Trash2 } from 'lucide-react';

const FacebookDisconnectModal = ({ isOpen, onClose, onConfirm, isLoading, pageCount }) => {
  const [confirmText, setConfirmText] = useState('');

  const handleConfirm = () => {
    if (confirmText.trim().toUpperCase() === 'DISCONNECT') {
      onConfirm();
    }
  };

  const handleClose = () => {
    setConfirmText('');
    onClose();
  };

  if (!isOpen) return null;

  const isConfirmEnabled = confirmText.trim().toUpperCase() === 'DISCONNECT';

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg max-w-md w-full p-6">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-red-100 rounded-full flex items-center justify-center">
              <AlertTriangle className="w-5 h-5 text-red-600" />
            </div>
            <h2 className="text-lg font-semibold text-gray-900">Disconnect Facebook</h2>
          </div>
          <button onClick={handleClose} className="text-gray-400 hover:text-gray-600" disabled={isLoading}>
            <X className="h-5 w-5" />
          </button>
        </div>

        <div className="mb-6">
          <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-4">
            <div className="flex items-start space-x-3">
              <Trash2 className="w-5 h-5 text-red-600 mt-0.5 flex-shrink-0" />
              <div>
                <h3 className="text-sm font-medium text-red-800 mb-1">
                  This will permanently delete all Facebook data
                </h3>
                <p className="text-sm text-red-700 mb-2">Disconnecting will:</p>
                <ul className="text-sm text-red-700 list-disc list-inside space-y-1">
                  <li>Disconnect {pageCount} Facebook page{pageCount !== 1 ? 's' : ''}</li>
                  <li>Delete all Facebook-sourced tickets</li>
                  <li>Remove customer conversations</li>
                  <li>Stop receiving new messages</li>
                </ul>
                <p className="text-sm text-red-700 mt-2 font-medium">
                  This action cannot be undone.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Type <code className="bg-gray-100 px-2 py-1 rounded text-red-600 font-mono">DISCONNECT</code> to confirm:
          </label>
          <input
            type="text"
            value={confirmText}
            onChange={(e) => setConfirmText(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-red-500"
            placeholder="Type DISCONNECT..."
            disabled={isLoading}
            autoFocus
          />
        </div>

        <div className="flex justify-end space-x-3">
          <button
            onClick={handleClose}
            className="px-4 py-2 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors"
            disabled={isLoading}
          >
            Cancel
          </button>
          <button
            onClick={handleConfirm}
            disabled={!isConfirmEnabled || isLoading}
            className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors flex items-center space-x-2"
          >
            {isLoading && <div className="animate-spin rounded-full h-4 w-4 border-2 border-white border-t-transparent" />}
            <span>{isLoading ? 'Disconnecting...' : 'Disconnect Facebook'}</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default FacebookDisconnectModal;